import React from "react";
import { FaCheckCircle } from "react-icons/fa";

const ThirdStep = () => {
  return (
    <div
      style={{ textAlign: "center", marginTop: "-20px", marginBottom: "20px" }}
    >
      <div style={{ color: "green", fontSize: 60 }}>
        <FaCheckCircle />
      </div>
      <p style={{ marginBottom: 0, color: "black" }}>
        Project Created Successfully!
      </p>
      <small>
        Thank you for creating new project in our platform, the project will be
        listed in the projects section.
      </small>
    </div>
  );
};

export default ThirdStep;
